import { useEffect, useMemo, useState } from "react";
import SocketService from "../../Service/SocketService";
import { DOMAIN } from "../../utils/constants";

const useSocketSync = (propertyData, user_id = null, emitterName = "sync") => {
    const [syncData, setSyncData] = useState([]);

    const itemsKey = useMemo(
        () => propertyData?.map((item) => item.id ?? item.property_id ?? "").join(",") ?? "",
        [propertyData]
    );

    useEffect(() => {
        if (!itemsKey) {
            setSyncData([]);
            return;
        }
        const isSession = emitterName === "session_sync_res";
        const syncEmitData = propertyData?.map((item) =>
            isSession
                ? { session_id: item.id, domain_id: DOMAIN, user_id }
                : { property_id: item.property_id, domain_id: DOMAIN, auction_id: item.auction_id, user_id }
        );
        const sync = () => {
            SocketService.send(isSession ? "session_sync" : "sync", { data: syncEmitData, emitterName });
        };

        sync();
        const intervalId = setInterval(sync, 15000);

        const handleSync = ({ error, data }) => {
            if (error) {
                console.error(error);
                return;
            }
            data = data.filter((item) => item !== null);
            setSyncData((prevData) =>
                prevData.length === data.length &&
                    prevData.every((item, index) => item === data[index])
                    ? prevData
                    : [...data]
            );
        };

        SocketService.on(emitterName, handleSync);

        const handleReconnect = () => sync();
        SocketService.on("connect", handleReconnect);

        return () => {
            clearInterval(intervalId);
            SocketService.off(emitterName, handleSync);
            SocketService.off("connect", handleReconnect);
        };
    }, [itemsKey, user_id, emitterName]);

    return syncData;
};

export default useSocketSync;
